import {
  ChakraDivider,
  ChakraFlex,
  ChakraGridItem,
  ChakraHStack,
  ChakraSimpleGrid,
  ChakraText,
  EquipUIFireflyV2Theme,
  EquipUITheme,
  User,
} from '@equip.health/ui';

import { PATIENT_HEADER_TOP_LEVEL_ID } from '~/components/maud/patients/profile/patient-header/patientHeaderConstants';
import { NOT_ON_FILE } from '~/lib/constants/patients.constants';

const { label, labelBold } = EquipUITheme.typography;

const { secondary } = EquipUIFireflyV2Theme.colors;

interface Props {
  gender: string;
  pronouns: string[];
  title: string;
}

export const PatientHeaderGenderPronounsCard = ({
  title,
  gender,
  pronouns,
}: Props) => {
  const pronounsList = pronouns?.length > 0 ? pronouns : [NOT_ON_FILE];
  return (
    <ChakraSimpleGrid
      flexDirection="column"
      id={`${PATIENT_HEADER_TOP_LEVEL_ID}__gender-pronouns-card`}
      spacing={2}
    >
      <ChakraGridItem>
        <ChakraHStack>
          <User fill={secondary[50]} height="12px" width="12px" />
          <ChakraText
            {...labelBold}
            color="neutral.primary"
            id={`${PATIENT_HEADER_TOP_LEVEL_ID}__gender-pronouns-title`}
          >
            {title}
          </ChakraText>
        </ChakraHStack>
      </ChakraGridItem>
      <ChakraGridItem>
        <ChakraSimpleGrid
          borderColor="red"
          columns={3}
          templateColumns="40% 5% 55%"
        >
          <ChakraGridItem>
            <ChakraText
              {...label}
              color="neutral.primary"
              id={`${PATIENT_HEADER_TOP_LEVEL_ID}__gender-text`}
            >
              {gender || NOT_ON_FILE}
            </ChakraText>
          </ChakraGridItem>
          <ChakraGridItem>
            <ChakraDivider
              alignContent="center"
              borderLeftWidth="2px"
              colorScheme="rgba(0, 0, 0, 0.1)"
              height="25px"
              id={`${PATIENT_HEADER_TOP_LEVEL_ID}__gender-pronouns-divider`}
              marginBottom="5px"
              marginTop="5px"
              orientation="vertical"
              width="10px"
            />
          </ChakraGridItem>
          <ChakraGridItem>
            <ChakraFlex
              direction="column"
              id={`${PATIENT_HEADER_TOP_LEVEL_ID}__pronouns`}
            >
              {pronounsList.map((pronoun) => (
                <ChakraText {...label} color="neutral.secondary" key={pronoun}>
                  {pronoun}
                </ChakraText>
              ))}
            </ChakraFlex>
          </ChakraGridItem>
        </ChakraSimpleGrid>
      </ChakraGridItem>
    </ChakraSimpleGrid>
  );
};
